import React, { Component } from 'react';
import networkList from '../../../../constants/networkList';
const {homepage} = networkList;
class Role_List extends Component {
    render() {
        return (
            <div>
                <div className="card m-5 card-table">
                    <div className="card-header bg8">                    
                            <div className="pt-1">
                            Role List
                            </div>                                                       
                    </div>
                  <div className="financial-table table-responsive">                 
                        <table className="table table-hover table-bordered mb-0">
                            <thead>
                                <tr>

                                    <td>Role Name</td>
                                    <td>Unit</td>
                                    <td>Users</td>
                                    <td>Permisions</td>
                                    <td>Action</td>                                   
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Counsellor</td>
                                    <td>Kondapur, Kims</td>
                                    <td>6</td>
                                    <td>(ER) Admissions, (ER) Billing Queries, Financial Counselling</td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit"></img></td>                                  
                                </tr>
                                <tr>
                                    <td>Counsellor</td>
                                    <td>Kondapur, Kims</td>
                                    <td>6</td>
                                    <td>(ER) Admissions, (ER) Billing Queries, Financial Counselling</td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit"></img></td>                                  
                                </tr>
                                <tr>
                                    <td>Counsellor</td>
                                    <td>Kondapur, Kims</td>
                                    <td>6</td>
                                    <td>(ER) Admissions, (ER) Billing Queries, Financial Counselling</td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit"></img></td>                                  
                                </tr>
                                <tr>
                                    <td>Counsellor</td>
                                    <td>Kondapur, Kims</td>
                                    <td>6</td>
                                    <td>(ER) Admissions, (ER) Billing Queries, Financial Counselling</td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit"></img></td>                                  
                                </tr>
                                <tr>
                                    <td>Counsellor</td>
                                    <td>Kondapur, Kims</td>
                                    <td>6</td>
                                    <td>(ER) Admissions, (ER) Billing Queries, Financial Counselling</td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit"></img></td>                                  
                                </tr>
                                <tr>
                                    <td>Counsellor</td>
                                    <td>Kondapur, Kims</td>
                                    <td>6</td>
                                    <td>(ER) Admissions, (ER) Billing Queries, Financial Counselling</td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit"></img></td>                                  
                                </tr>
                                <tr>
                                    <td>Counsellor</td>
                                    <td>Kondapur, Kims</td>
                                    <td>6</td>
                                    <td>(ER) Admissions, (ER) Billing Queries, Financial Counselling</td>
                                    <td><img src={homepage+"/assets/images/icons/edit.png"} alt="edit"></img></td>                                  
                                </tr>                     
                            </tbody>
                        </table>
                    </div>
                </div>               
            </div>
        )
    }
}

export default Role_List;